import { useContext } from "react";

import { DeviceInfoContext } from "../DeviceInfoProvider";

/** Simple hook to return information about current device. */

export const useDeviceInfo = () => useContext(DeviceInfoContext);
